import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../Media/Logo.png";

/** Anchor links (used on the landing page only). */
const HOME_LINKS = [
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Research Articles", href: "#writing" },
  { label: "Films", href: "#films" },
  { label: "Services", href: "#services" },
];

/** Route links (used on every non-landing public page). */
const AWAY_LINKS = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/ViewProjects" },
  { label: "Research Articles", to: "/ViewArticles" },
  { label: "Films", to: "/ViewVideos" },
  { label: "Services", to: "/services" },
];

export default function Topbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const links = onHome ? HOME_LINKS : AWAY_LINKS;

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const renderLink = (l) =>
    l.to ? (
      <Link to={l.to} onClick={() => setOpen(false)}>
        {l.label}
      </Link>
    ) : (
      <a href={l.href} onClick={() => setOpen(false)}>
        {l.label}
      </a>
    );

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/" className="brand">
            <img src={Logo} alt="Anas Nasir" className="brand-logo" />
            <span className="brand-text">Anas&nbsp;Nasir</span>
          </Link>

          <nav>
            <ul className="nav-links">
              {links.map((l) => (
                <li key={l.label}>{renderLink(l)}</li>
              ))}
            </ul>
          </nav>

          <a href="#contact" className="nav-cta">
            Get in Touch
          </a>

          <button
            className="nav-toggle"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
          >
            <i className="bi bi-list" />
          </button>
        </div>
      </header>

      <div className={`nav-mobile ${open ? "open" : ""}`}>
        <div className="nav-mobile-head">
          <span className="brand">
            <img src={Logo} alt="Anas Nasir" className="brand-logo" />
            <span className="brand-text">Anas&nbsp;Nasir</span>
          </span>
          <button
            className="nav-toggle"
            aria-label="Close menu"
            style={{ display: "inline-flex" }}
            onClick={() => setOpen(false)}
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <ul className="nav-mobile-links">
          {links.map((l) => (
            <li key={l.label}>{renderLink(l)}</li>
          ))}
          <li>
            <a href="#contact" onClick={() => setOpen(false)}>
              Contact
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
